import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=37f80184&scoped=true&"
import script from "./news1.vue?vue&type=script&lang=js&"
export * from "./news1.vue?vue&type=script&lang=js&"
import style0 from "./news1.vue?vue&type=style&index=0&id=37f80184&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f80184",
  null
  
)

export default component.exports